import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import CreateEditCustomer from "../../components/customer/CreateEditCustomer";

const CreateEditCustomerPage = (props) => {
    const {
        customerId  = null,
    } = props;

    const handleCancel = () => {
        if (!!customerId) {
            window.location.replace(route('customer.show', {
                customer:   customerId,
            }).toString());
        } else {
            window.location.replace(route('customer.index', {
                customer:   customerId,
            }).toString());
        }
    }

    const handleComplete = (customer) => {
        window.location.replace(route('customer.show', {
            customer:   customer,
        }).toString());
    }

    const handleDelete = () => {
        window.location.replace(route('customer.index').toString());
    }

    return (
        <div className="m-0 mb-4 p-0">
            <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                <h1 className="h4 m-0 text-eh-navy">{!!customerId ? "Edit Customer" : "Create Customer"}</h1>
            </div>
            <CreateEditCustomer
                customerId={customerId}
                onCancel={() => handleCancel()}
                onComplete={(customer) => handleComplete(customer)}
                onDelete={() => handleDelete()}
                parentId={"create-edit-customer-page"}
            />
        </div>
    );
}

export default CreateEditCustomerPage;

const target = document.getElementById('create-edit-customer-page');
if (target) {
    const {
        customerId  = null,
    } = target.dataset;

    ReactDOM.render(<CreateEditCustomerPage customerId={customerId} />, target);
}
